import type { Comic, Category, Chapter, Review } from '@/types';

export const categories: Category[] = [
  { id: 'romance', name: '恋爱漫画', slug: 'romance', description: '甜蜜浪漫的韩国恋爱漫画，感受心动瞬间', icon: 'ri-heart-line' },
  { id: 'action', name: '热血动作', slug: 'action', description: '热血沸腾的动作漫画，激燃打斗场面', icon: 'ri-sword-line' },
  { id: 'fantasy', name: '奇幻冒险', slug: 'fantasy', description: '奇幻世界冒险旅程，异世界转生题材', icon: 'ri-magic-line' },
  { id: 'drama', name: '都市剧情', slug: 'drama', description: '都市生活剧情漫画，现实题材佳作', icon: 'ri-building-line' },
  { id: 'thriller', name: '悬疑惊悚', slug: 'thriller', description: '扣人心弦的悬疑惊悚漫画', icon: 'ri-ghost-line' },
  { id: 'comedy', name: '搞笑日常', slug: 'comedy', description: '轻松搞笑的日常生活漫画', icon: 'ri-emotion-laugh-line' },
  { id: 'bl', name: 'BL漫画', slug: 'bl', description: '高品质韩国BL漫画作品', icon: 'ri-user-heart-line' },
  { id: 'gl', name: 'GL漫画', slug: 'gl', description: '精品韩国GL百合漫画', icon: 'ri-hearts-line' },
];

export const comics: Comic[] = [
  {
    id: 1,
    title: '社内恋爱',
    author: '金敏秀',
    category: 'romance',
    tags: ['恋爱', '职场', '甜宠'],
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20style%20romance%20cover%20illustration%2C%20two%20young%20office%20workers%20in%20elegant%20formal%20wear%2C%20soft%20warm%20lighting%2C%20romantic%20atmosphere%2C%20delicate%20lineart%2C%20pastel%20pink%20and%20cream%20background%2C%20Korean%20webtoon%20art%20style%2C%20clean%20soft%20colors&width=800&height=1100&seq=comic-cover-01&orientation=portrait',
    description: '刚入职场的李多恩意外发现自己的上司竟然是大学时期的暗恋对象。在职场与情感的双重考验下，两人的关系逐渐升温。一部甜蜜又真实的职场恋爱漫画。',
    status: '连载中',
    rating: 9.2,
    views: 1285000,
    updatedAt: '2026-07-07',
    chapters: [
      { id: 1, title: '第1话 意外的重逢', number: 1, updatedAt: '2026-06-01' },
      { id: 2, title: '第2话 心跳加速的瞬间', number: 2, updatedAt: '2026-06-08' },
      { id: 3, title: '第3话 办公室的秘密', number: 3, updatedAt: '2026-06-15' },
      { id: 4, title: '第4话 躲不过的眼神', number: 4, updatedAt: '2026-06-22' },
      { id: 5, title: '第5话 深夜加班', number: 5, updatedAt: '2026-06-29' },
      { id: 6, title: '第6话 心跳告白', number: 6, updatedAt: '2026-07-06' },
    ],
  },
  {
    id: 2,
    title: '剑与魔法',
    author: '朴志勋',
    category: 'fantasy',
    tags: ['奇幻', '冒险', '转生'],
    cover: 'https://readdy.ai/api/search-image?query=A%20stunning%20Korean%20manhwa%20fantasy%20cover%2C%20a%20warrior%20holding%20a%20glowing%20sword%20in%20a%20magical%20forest%2C%20magical%20particles%20floating%2C%20epic%20atmosphere%2C%20Korean%20webtoon%20art%20style%2C%20vibrant%20greens%20and%20golden%20accents%2C%20dramatic%20lighting%2C%20clean%20background&width=800&height=1100&seq=comic-cover-02&orientation=portrait',
    description: '平凡的程序员金宇振在加班途中意外猝死，醒来后发现自己穿越到了剑与魔法的奇幻世界。凭借前世的记忆和系统外挂，他将在这个世界掀起一场风暴。',
    status: '连载中',
    rating: 9.5,
    views: 2350000,
    updatedAt: '2026-07-06',
    chapters: [
      { id: 7, title: '第1话 穿越异世界', number: 1, updatedAt: '2026-05-01' },
      { id: 8, title: '第2话 觉醒的系统', number: 2, updatedAt: '2026-05-08' },
      { id: 9, title: '第3话 第一次战斗', number: 3, updatedAt: '2026-05-15' },
      { id: 10, title: '第4话 公会的邀请', number: 4, updatedAt: '2026-05-22' },
      { id: 11, title: '第5话 迷宫的试炼', number: 5, updatedAt: '2026-05-29' },
      { id: 12, title: '第6话 隐藏的真相', number: 6, updatedAt: '2026-06-05' },
      { id: 13, title: '第7话 龙之谷', number: 7, updatedAt: '2026-06-12' },
      { id: 14, title: '第8话 觉醒之力', number: 8, updatedAt: '2026-06-19' },
    ],
  },
  {
    id: 3,
    title: '恶女的救赎',
    author: '崔恩珠',
    category: 'drama',
    tags: ['剧情', '重生', '复仇'],
    cover: 'https://readdy.ai/api/search-image?query=A%20gorgeous%20Korean%20manhwa%20drama%20cover%2C%20an%20elegant%20noblewoman%20in%20a%20luxurious%20gown%2C%20cold%20expression%2C%20royal%20palace%20interior%20background%2C%20dramatic%20lighting%20from%20window%2C%20Korean%20webtoon%20art%20style%2C%20deep%20burgundy%20and%20gold%20tones%2C%20regal%20atmosphere&width=800&height=1100&seq=comic-cover-03&orientation=portrait',
    description: '前世被丈夫背叛、被家族抛弃的贵族小姐韩素英，在临死前获得了重生的机会。回到二十岁的她发誓要让所有伤害过她的人都付出代价。',
    status: '已完结',
    rating: 9.7,
    views: 5680000,
    updatedAt: '2026-06-30',
    chapters: [
      { id: 15, title: '第1话 死亡与重生', number: 1, updatedAt: '2025-08-01' },
      { id: 16, title: '第2话 回到二十岁', number: 2, updatedAt: '2025-08-08' },
      { id: 17, title: '第3话 第一步棋', number: 3, updatedAt: '2025-08-15' },
    ],
  },
  {
    id: 4,
    title: '校园怪谈',
    author: '李承佑',
    category: 'thriller',
    tags: ['悬疑', '恐怖', '校园'],
    cover: 'https://readdy.ai/api/search-image?query=A%20mysterious%20Korean%20manhwa%20thriller%20cover%2C%20a%20school%20corridor%20at%20night%20with%20an%20eerie%20shadow%20figure%2C%20moonlight%20through%20windows%2C%20dark%20atmosphere%2C%20Korean%20webtoon%20art%20style%2C%20cool%20blue%20and%20dark%20gray%20tones%2C%20suspenseful%20mood&width=800&height=1100&seq=comic-cover-04&orientation=portrait',
    description: '新月高中流传着七个校园怪谈。转学生尹在民不信鬼神，直到他在深夜的走廊里亲眼目睹了第一桩怪谈。从那以后，诡异的事件接连发生……',
    status: '连载中',
    rating: 9.0,
    views: 980000,
    updatedAt: '2026-07-05',
    chapters: [
      { id: 18, title: '第1话 转学生', number: 1, updatedAt: '2026-04-01' },
      { id: 19, title: '第2话 深夜的走廊', number: 2, updatedAt: '2026-04-08' },
      { id: 20, title: '第3话 镜中的脸', number: 3, updatedAt: '2026-04-15' },
      { id: 21, title: '第4话 消失的同学', number: 4, updatedAt: '2026-04-22' },
    ],
  },
  {
    id: 5,
    title: '便利店男友',
    author: '郑荷娜',
    category: 'comedy',
    tags: ['搞笑', '日常', '甜宠'],
    cover: 'https://readdy.ai/api/search-image?query=A%20cute%20Korean%20manhwa%20comedy%20cover%2C%20a%20young%20couple%20at%20a%20convenience%20store%2C%20eating%20ramen%20together%2C%20funny%20expressions%2C%20warm%20evening%20lighting%2C%20Korean%20webtoon%20art%20style%2C%20bright%20and%20lively%20colors%2C%20cozy%20atmosphere&width=800&height=1100&seq=comic-cover-05&orientation=portrait',
    description: '失业青年金泰浩为了维持生计在便利店打工，却没想到在这里遇到了形形色色的有趣人物。最离谱的是，他的"便利店男友"称号不知怎么传遍了整个社区……',
    status: '连载中',
    rating: 8.8,
    views: 756000,
    updatedAt: '2026-07-04',
    chapters: [
      { id: 22, title: '第1话 便利店的夜晚', number: 1, updatedAt: '2026-05-01' },
      { id: 23, title: '第2话 奇怪的客人', number: 2, updatedAt: '2026-05-08' },
      { id: 24, title: '第3话 拉面之约', number: 3, updatedAt: '2026-05-15' },
    ],
  },
  {
    id: 6,
    title: '花开时节',
    author: '宋智雅',
    category: 'bl',
    tags: ['BL', '青春', '治愈'],
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20BL%20manhwa%20cover%2C%20two%20young%20men%20standing%20under%20cherry%20blossom%20trees%2C%20gentle%20expressions%2C%20soft%20spring%20lighting%2C%20pink%20petals%20falling%2C%20Korean%20webtoon%20art%20style%2C%20dreamy%20pastel%20colors%2C%20romantic%20atmosphere&width=800&height=1100&seq=comic-cover-06&orientation=portrait',
    description: '高中三年级的韩叙俊在樱花盛开的季节遇到了转学生沈星宇。两个性格截然不同的少年因为一次意外碰撞，开始了一段刻骨铭心的青春故事。',
    status: '连载中',
    rating: 9.3,
    views: 1890000,
    updatedAt: '2026-07-07',
    chapters: [
      { id: 25, title: '第1话 樱花下的相遇', number: 1, updatedAt: '2026-03-01' },
      { id: 26, title: '第2话 图书馆的午后', number: 2, updatedAt: '2026-03-08' },
      { id: 27, title: '第3话 心跳的距离', number: 3, updatedAt: '2026-03-15' },
      { id: 28, title: '第4话 雨中的告白', number: 4, updatedAt: '2026-03-22' },
      { id: 29, title: '第5话 属于我们的夏天', number: 5, updatedAt: '2026-03-29' },
    ],
  },
  {
    id: 7,
    title: '月光宫殿',
    author: '尹素拉',
    category: 'gl',
    tags: ['GL', '古风', '宫廷'],
    cover: 'https://readdy.ai/api/search-image?query=A%20gorgeous%20Korean%20GL%20manhwa%20cover%2C%20two%20beautiful%20women%20in%20traditional%20Korean%20hanbok%20dresses%2C%20moonlit%20palace%20courtyard%2C%20elegant%20atmosphere%2C%20Korean%20webtoon%20art%20style%2C%20soft%20silver%20and%20lavender%20tones%2C%20romantic%20night%20scene&width=800&height=1100&seq=comic-cover-07&orientation=portrait',
    description: '朝鲜时代的公主李华英在月光下的宫殿中遇见了神秘的宫女金素月。在那个保守的年代，两个女子的秘密恋情在月光下悄然绽放。',
    status: '连载中',
    rating: 9.1,
    views: 1120000,
    updatedAt: '2026-07-03',
    chapters: [
      { id: 30, title: '第1话 月光下的邂逅', number: 1, updatedAt: '2026-04-01' },
      { id: 31, title: '第2话 宫女的秘密', number: 2, updatedAt: '2026-04-08' },
      { id: 32, title: '第3话 月夜私语', number: 3, updatedAt: '2026-04-15' },
    ],
  },
  {
    id: 8,
    title: '武林至尊',
    author: '韩东旭',
    category: 'action',
    tags: ['武侠', '热血', '格斗'],
    cover: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Korean%20manhwa%20action%20cover%2C%20a%20martial%20arts%20master%20in%20mid%20combat%20pose%2C%20flowing%20robes%2C%20energy%20waves%2C%20dramatic%20action%20scene%2C%20Korean%20webtoon%20art%20style%2C%20intense%20red%20and%20black%20contrast%2C%20powerful%20atmosphere&width=800&height=1100&seq=comic-cover-08&orientation=portrait',
    description: '被灭门的武林世家唯一幸存者姜太昊，隐姓埋名苦练十年后重出江湖。他要找到灭门仇人，也要在这群雄逐鹿的武林中登上至尊之位。',
    status: '连载中',
    rating: 9.4,
    views: 3150000,
    updatedAt: '2026-07-06',
    chapters: [
      { id: 33, title: '第1话 灭门之夜', number: 1, updatedAt: '2025-12-01' },
      { id: 34, title: '第2话 深山修炼', number: 2, updatedAt: '2025-12-08' },
      { id: 35, title: '第3话 初入江湖', number: 3, updatedAt: '2025-12-15' },
      { id: 36, title: '第4话 比武大会', number: 4, updatedAt: '2025-12-22' },
      { id: 37, title: '第5话 宿敌现身', number: 5, updatedAt: '2025-12-29' },
    ],
  },
  {
    id: 9,
    title: '甜蜜陷阱',
    author: '朴秀妍',
    category: 'romance',
    tags: ['恋爱', '甜宠', '契约'],
    cover: 'https://readdy.ai/api/search-image?query=A%20sweet%20Korean%20manhwa%20romance%20cover%2C%20a%20handsome%20CEO%20and%20a%20cute%20young%20woman%20in%20a%20modern%20office%2C%20contract%20marriage%20theme%2C%20luxurious%20setting%2C%20Korean%20webtoon%20art%20style%2C%20warm%20golden%20and%20rose%20tones%2C%20romantic%20mood&width=800&height=1100&seq=comic-cover-09&orientation=portrait',
    description: '为了偿还父亲的债务，崔雅琳被迫与财阀继承人郑宇贤签订了一年的契约恋爱。她以为这只是一场交易，却不知不觉陷入了甜蜜的陷阱。',
    status: '连载中',
    rating: 9.0,
    views: 1650000,
    updatedAt: '2026-07-05',
    chapters: [
      { id: 38, title: '第1话 一纸契约', number: 1, updatedAt: '2026-05-01' },
      { id: 39, title: '第2话 假装恋人', number: 2, updatedAt: '2026-05-08' },
      { id: 40, title: '第3话 同居生活', number: 3, updatedAt: '2026-05-15' },
    ],
  },
  {
    id: 10,
    title: '重生之逆袭',
    author: '张瑞元',
    category: 'fantasy',
    tags: ['重生', '逆袭', '爽文'],
    cover: 'https://readdy.ai/api/search-image?query=A%20powerful%20Korean%20manhwa%20rebirth%20cover%2C%20a%20determined%20young%20man%20with%20glowing%20eyes%2C%20cityscape%20background%2C%20dramatic%20transformation%2C%20Korean%20webtoon%20art%20style%2C%20bold%20gold%20and%20crimson%20colors%2C%20triumphant%20atmosphere&width=800&height=1100&seq=comic-cover-10&orientation=portrait',
    description: '被朋友背叛、被女友抛弃的底层青年刘振赫含恨而死。睁眼后竟回到了十年前，这一次他掌握了所有先机，决定用前世积累的经验逆袭人生。',
    status: '连载中',
    rating: 9.6,
    views: 4210000,
    updatedAt: '2026-07-07',
    chapters: [
      { id: 41, title: '第1话 不甘的死亡', number: 1, updatedAt: '2025-10-01' },
      { id: 42, title: '第2话 回到过去', number: 2, updatedAt: '2025-10-08' },
      { id: 43, title: '第3话 第一桶金', number: 3, updatedAt: '2025-10-15' },
      { id: 44, title: '第4话 股市风暴', number: 4, updatedAt: '2025-10-22' },
      { id: 45, title: '第5话 昔日仇人', number: 5, updatedAt: '2025-10-29' },
      { id: 46, title: '第6话 新的盟友', number: 6, updatedAt: '2025-11-05' },
    ],
  },
  {
    id: 11,
    title: '暗夜追踪',
    author: '赵贤宇',
    category: 'thriller',
    tags: ['悬疑', '推理', '犯罪'],
    cover: 'https://readdy.ai/api/search-image?query=A%20tense%20Korean%20manhwa%20crime%20thriller%20cover%2C%20a%20detective%20in%20a%20dark%20alley%20at%20night%2C%20rain%20falling%2C%20neon%20signs%20reflecting%2C%20Korean%20webtoon%20art%20style%2C%20moody%20blue%20and%20red%20lighting%2C%20noir%20atmosphere&width=800&height=1100&seq=comic-cover-11&orientation=portrait',
    description: '前刑警姜道贤开设了一家私人侦探所。一个雨夜，神秘女子带来一桩离奇案件，将他卷入了一场跨越十年的连环杀人案。',
    status: '连载中',
    rating: 8.9,
    views: 870000,
    updatedAt: '2026-07-02',
    chapters: [
      { id: 47, title: '第1话 雨夜来客', number: 1, updatedAt: '2026-04-01' },
      { id: 48, title: '第2话 旧案重提', number: 2, updatedAt: '2026-04-08' },
      { id: 49, title: '第3话 第一个嫌疑人', number: 3, updatedAt: '2026-04-15' },
    ],
  },
  {
    id: 12,
    title: '女王的棋局',
    author: '安素熙',
    category: 'drama',
    tags: ['剧情', '权力', '商战'],
    cover: 'https://readdy.ai/api/search-image?query=A%20sophisticated%20Korean%20manhwa%20business%20drama%20cover%2C%20a%20confident%20woman%20in%20a%20power%20suit%20in%20a%20corporate%20boardroom%2C%20city%20skyline%20through%20window%2C%20Korean%20webtoon%20art%20style%2C%20cool%20gray%20and%20burgundy%20tones%2C%20professional%20atmosphere&width=800&height=1100&seq=comic-cover-12&orientation=portrait',
    description: '在男性主导的韩国财阀世界中，白秀雅凭借惊人的商业头脑一步步登上集团会长的宝座。但这盘棋远没有结束，真正的敌人还在暗中等待时机。',
    status: '已完结',
    rating: 9.3,
    views: 1980000,
    updatedAt: '2026-06-15',
    chapters: [
      { id: 50, title: '第1话 继承之战', number: 1, updatedAt: '2025-06-01' },
      { id: 51, title: '第2话 棋局开始', number: 2, updatedAt: '2025-06-08' },
    ],
  },
];

export const reviews: Review[] = [
  {
    id: 1,
    username: '漫迷小樱',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cute%20anime%20style%20girl%20avatar%20with%20pink%20hair%2C%20simple%20clean%20background%2C%20pastel%20colors%2C%20circle%20format%2C%20chibi%20style&width=96&height=96&seq=avatar-01&orientation=squarish',
    content: '韩漫画网的阅读体验真的太棒了！下拉式阅读非常流畅，不用翻页就能一直看下去。漫画资源也很全面，基本上想看的韩漫都能找到。强烈推荐给所有喜欢韩国漫画的朋友！',
    rating: 5,
    date: '2026-07-01',
  },
  {
    id: 2,
    username: '热血少年团',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cool%20anime%20style%20boy%20avatar%20with%20spiky%20dark%20hair%2C%20determined%20expression%2C%20simple%20background%2C%20vibrant%20colors%2C%20circle%20format&width=96&height=96&seq=avatar-02&orientation=squarish',
    content: '动作类漫画更新速度很快，画质也很清晰。特别喜欢剑与魔法和武林至尊这两部，每周都在追更新。希望以后能出更多的热血类韩漫！',
    rating: 4,
    date: '2026-07-02',
  },
  {
    id: 3,
    username: '深夜追更人',
    avatar: 'https://readdy.ai/api/search-image?query=A%20mysterious%20anime%20style%20character%20avatar%20with%20glasses%2C%20dark%20hair%2C%20calm%20expression%2C%20simple%20dark%20background%2C%20circle%20format&width=96&height=96&seq=avatar-03&orientation=squarish',
    content: '每天晚上躺在床上看韩漫已经成了我的固定习惯。网站的界面设计简洁好看，没有杂乱的广告打扰阅读。恶女的救赎结局太精彩了，哭了好几次。',
    rating: 5,
    date: '2026-07-03',
  },
  {
    id: 4,
    username: '漫画收藏家',
    avatar: 'https://readdy.ai/api/search-image?query=A%20stylish%20anime%20style%20girl%20avatar%20with%20short%20silver%20hair%2C%20fashionable%20look%2C%20simple%20pastel%20background%2C%20circle%20format&width=96&height=96&seq=avatar-04&orientation=squarish',
    content: '韩漫画网的分类做得很细致，找漫画很方便。收藏功能也很好用，可以随时看到自己追的漫画更新情况。已经推荐给身边所有喜欢看漫画的朋友了！',
    rating: 5,
    date: '2026-07-04',
  },
  {
    id: 5,
    username: '草莓味冰淇淋',
    avatar: 'https://readdy.ai/api/search-image?query=A%20sweet%20anime%20style%20girl%20avatar%20with%20twin%20tails%2C%20pink%20hair%2C%20happy%20smile%2C%20soft%20pastel%20background%2C%20circle%20format&width=96&height=96&seq=avatar-05&orientation=squarish',
    content: 'BL和恋爱漫画资源特别全，花开时节和社内恋爱是我最近的心头好！站长选品眼光真的很不错，推荐的作品质量都很高。',
    rating: 4,
    date: '2026-07-05',
  },
  {
    id: 6,
    username: '电竞少年阿宇',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cool%20anime%20style%20boy%20avatar%20with%20headphones%2C%20casual%20style%2C%20blue%20hair%2C%20simple%20background%2C%20circle%20format&width=96&height=96&seq=avatar-06&orientation=squarish',
    content: '网站加载速度很快，漫画图片加载也不卡顿。重生之逆袭这部漫画太上头了，看了一话就停不下来。期待能加入更多韩漫资源！',
    rating: 5,
    date: '2026-07-06',
  },
];

export const faqs = [
  {
    question: '韩漫画网的漫画资源都是正版的吗？',
    answer: '韩漫画网致力于为正版韩国漫画提供优质的阅读平台，我们与多家韩国漫画出版社保持合作，为用户提供合法授权的漫画内容。',
  },
  {
    question: '什么是下拉式漫画阅读？',
    answer: '下拉式漫画阅读是一种优化的移动端阅读方式，您只需向下滑动屏幕即可连续阅读漫画内容，无需点击翻页按钮，阅读体验更流畅自然。',
  },
  {
    question: '需要注册账号才能看漫画吗？',
    answer: '韩漫画网大部分漫画内容都可以免费在线观看，无需注册账号。部分独家内容可能需要注册账号后才能阅读。',
  },
  {
    question: '漫画更新频率是怎样的？',
    answer: '热门连载漫画通常每周更新一话，具体更新时间可以在每部漫画的详情页查看。已完结作品则可以一次性阅读全部章节。',
  },
  {
    question: '可以在手机上观看漫画吗？',
    answer: '当然可以！韩漫画网采用响应式设计，完美适配手机、平板和电脑等各类设备，无论在什么设备上都能获得优质的阅读体验。',
  },
  {
    question: '如何找到我想看的漫画类型？',
    answer: '您可以通过网站顶部的搜索栏直接搜索漫画名称，也可以点击分类导航浏览不同类型的漫画，我们提供了恋爱、热血、奇幻等多种分类供您选择。',
  },
];